import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "box overflow sendSetting" }
const _hoisted_2 = { class: "settingBlockContainer" }
const _hoisted_3 = { class: "settingBlockArea" }
const _hoisted_4 = { class: "settingBlock left poRel" }
const _hoisted_5 = { class: "settingBlockText left" }
const _hoisted_6 = { class: "settingBlockArea" }
const _hoisted_7 = { class: "settingBlockArea" }
const _hoisted_8 = { class: "settingBlock left poRel" }
const _hoisted_9 = { class: "conBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "subTitle" }, "템플릿 발송 전 알림", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            ($data.api.AUMS_NOTI_YN == 'Y')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "blueBtn",
                  style: {"margin-top":"0"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.api.AUMS_NOTI_YN='N'))
                }, "발송"))
              : _createCommentVNode("", true),
            ($data.api.AUMS_NOTI_YN == 'N')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "redBtn",
                  style: {"margin-top":"0"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.api.AUMS_NOTI_YN='Y'))
                }, "발송안함"))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "selectBox right",
            style: {"margin-left":"10px"},
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.api.AUMS_NOTI_TM) = $event))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("option", { value: "7" }, "7시", -1),
            _createElementVNode("option", { value: "8" }, "8시", -1),
            _createElementVNode("option", { value: "9" }, "9시", -1),
            _createElementVNode("option", { value: "10" }, "10시", -1)
          ]))], 512), [
            [_vModelSelect, $data.api.AUMS_NOTI_TM]
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "selectBox right",
            style: {"margin-right":"0"},
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.api.AUMS_NOTI_DAY) = $event))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("option", { value: "0" }, "당일", -1),
            _createElementVNode("option", { value: "1" }, "1일전", -1),
            _createElementVNode("option", { value: "2" }, "2일전", -1),
            _createElementVNode("option", { value: "3" }, "3일전", -1)
          ]))], 512), [
            [_vModelSelect, $data.api.AUMS_NOTI_DAY]
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "settingBlockword left mgL15" }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, "예약된 템플릿 메시지가 있는 경우 지정된 시간에 미리 알림을 받습니다. "),
            _createElementVNode("li", null, "JSD 어플이 설치되어 있지 않은 경우, 알림 메시지가 발송되지 않습니다. ")
          ])
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "subTitle" }, "주말, 공휴일 발송 여부", -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "settingBlockText left" }, "주말,공휴일 발송여부", -1)),
          _withDirectives(_createElementVNode("button", {
            class: "blueBtn right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.api.AUMS_HOLI_SEND_YN='N'))
          }, "발송", 512), [
            [_vShow, $data.api.AUMS_HOLI_SEND_YN == 'Y']
          ]),
          _withDirectives(_createElementVNode("button", {
            class: "redBtn right",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($data.api.AUMS_HOLI_SEND_YN='Y'))
          }, "발송안함", 512), [
            [_vShow, $data.api.AUMS_HOLI_SEND_YN == 'N']
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "settingBlockword left mgL15" }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, "템플릿 문자의 발송일이 주말(토/일요일)이나 공휴일인 경우 다음 평일에 발송합니다. ")
          ])
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "grayBtn",
        onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.getConfList()))
      }, " 취소 "),
      _cache[15] || (_cache[15] = _createTextVNode("   ", -1)),
      _createElementVNode("button", {
        class: "blueBtn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.conf_save()))
      }, " 저장 ")
    ])
  ]))
}